import { render, staticRenderFns } from "./expensemanagement.vue?vue&type=template&id=bc2b42c2&scoped=true"
import script from "./expensemanagement.vue?vue&type=script&lang=ts"
export * from "./expensemanagement.vue?vue&type=script&lang=ts"
import style0 from "./expensemanagement.vue?vue&type=style&index=0&id=bc2b42c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2b42c2",
  null
  
)

export default component.exports